import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Modal } from 'antd';

import { FormContextWrapperProvider } from 'contexts/compensation-form.context';

import CompensationContainer from './components/CompensationContainer';

const AddCompensationFormModal = ({
  onSuccess,
  close,
  onSumbit,
  delivery,
  isUpdate,

  ...props
}) => {
  const { formatMessage } = useIntl();
  const [totalAmount, setTotalAmount] = useState(0);
  const [amountLoading, setAmountLoading] = useState(false);
  const [isSumTotal, setIsSumTotal] = useState(false);

  useEffect(() => {
    if (isUpdate) {
      const amount = parseInt(delivery?.amount.replace(/,/g, ''));
      setTotalAmount(amount);
    }
  }, []);

  const okBtnDisabled = isUpdate
    ? !isSumTotal
    : amountLoading || totalAmount <= 0;

  return (
    <Modal
      onCancel={close}
      title={formatMessage({
        id: isUpdate
          ? 'request_compensation_modal.title_update'
          : 'request_compensation_modal.title'
      })}
      width={null}
      okText={formatMessage({
        id: isUpdate
          ? 'request_compensation_modal.update'
          : 'request_compensation_modal.confirm'
      })}
      className="br-add-compensation-form-modal__container"
      okButtonProps={{
        htmlType: 'submit',
        form: 'compensationInfoForm',
        disabled: okBtnDisabled
      }}
      {...props}
    >
      <FormContextWrapperProvider>
        <CompensationContainer
          totalAmount={totalAmount}
          setTotalAmount={isUpdate ? () => {} : setTotalAmount}
          amountLoading={amountLoading}
          setAmountLoading={isUpdate ? () => {} : setAmountLoading}
          setIsSumTotal={isUpdate ? setIsSumTotal : () => {}}
          delivery={delivery}
          close={close}
          onSuccess={onSuccess}
          isUpdate={isUpdate}
        />
      </FormContextWrapperProvider>
    </Modal>
  );
};

export default AddCompensationFormModal;
